import React from 'react';
import { SalesforceLogo } from '@ui/icons';
import { useCurrentOrganizationSubdomain } from '@hooks';
import { Button, Space } from 'antd';
import { COPY_SPECIFIC, LINKS } from '@sonar-software/sonar-ts-constants';
export const ViewConnectedAppsButton = () => React.createElement(Button, { href: LINKS.SALESFORCE_MANAGE_APPS(useCurrentOrganizationSubdomain()), id: 'view-connected-apps-button', target: '_blank', type: 'link' }, React.createElement(Space, { align: 'center', size: 'small' },
    React.createElement(SalesforceLogo, null),
    COPY_SPECIFIC.VIEW_CONNECTED_APPS_PAGE));
